import React, { useContext } from "react";
import { StateContext } from "../context/StateContextP";
import WebProjectPresention from "./WebProjectPresention";

const WebProjectDisplay = () => {
  const { webInfo } = useContext(StateContext);
  return(
  <div>
      {webInfo.map((info,i) =>{
          return(
              <WebProjectPresention
                key={i}
                img = {info.img}
                projectTitle = {info.projectTitle}
                projectDescription = {info.projectDescription}
                languages = {info.languages}
                frameworks = {info.frameworks}
              />
          )
      })}
  </div>
  );
};

export default WebProjectDisplay;
